import { z } from 'zod';
import { sectionHasValue } from '../util';
export const hhaPlanOfCareValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        PatientInformation: z.object({
            precautions: z.array(z.string()).optional(),
            allergies: z
                .array(z.object({
                allergy: z.string().optional(),
                severity: z.string().optional(),
            }))
                .optional(),
            conditions: z.array(z.string()).optional(),
            conditionsOther: z.string().nullish(),
            attentiveness: z.array(z.string()).optional(),
            attentivenessOther: z.string().nullish(),
            amputation: z.array(z.string()).optional(),
            paresis: z.array(z.string()).optional(),
            hearingAids: z.array(z.string()).optional(),
            dentures: z.array(z.string()).optional(),
            oxygen: z.string().optional(),
            oxygenOther: z.string().nullish(),
            bladderBowel: z.object({
                urinaryBladder: z.string().optional(),
                bowel: z.string().optional(),
                urine: z.string().optional(),
                urineOther: z.string().optional(),
            }),
            activity: z.array(z.string()).optional(),
            other: z.object({
                surgeryProcedure: z.string().optional(),
                precautionsDueToSurgery: z.string().optional(),
                dressingBandage: z.string().optional(),
                diet: z.string().optional(),
                fluids: z.string().optional(),
                otherDetails: z.string().optional(),
            }),
        }),
        Vitals: z.object({
            vitals: z.array(z.string()).optional(),
            temperature: z.string().optional(),
            temperatureOtherFrequency: z.string().optional(),
            temperatureOtherPeriod: z.string().optional(),
            bloodPressure: z.string().optional(),
            bloodPressureLocation: z.string().optional(),
            bloodPressureOtherFrequency: z.string().optional(),
            bloodPressureOtherPeriod: z.string().optional(),
            pulse: z.string().optional(),
            pulseOtherFrequency: z.string().optional(),
            pulseOtherPeriod: z.string().optional(),
            respiration: z.string().optional(),
            respirationOtherFrequency: z.string().optional(),
            respirationOtherPeriod: z.string().optional(),
            weight: z.string().optional(),
            weightOtherFrequency: z.string().optional(),
            weightOtherPeriod: z.string().optional(),
        }),
        Bathing: z.object({
            bathing: z.object({
                requiresBathing: z.boolean().optional(),
                frequency: z.string().optional(),
                frequencyOtherNumber: z.string().optional(),
                frequencyOtherPeriod: z.string().optional(),
                requires: z.string().optional(),
                bathType: z.string().optional(),
                bathTypeOther: z.string().optional(),
                entirety: z.string().optional(),
                safeLevel: z.string().optional(),
            }),
            dressing: z.string().optional(),
            dressingOther: z.string().optional(),
            availableEquipment: z.array(z.string()).optional(),
            availableEquipmentOther: z.string().optional(),
        }),
        PersonalCare: z.object({
            personalCare: z.object({
                requiresPersonalCare: z.boolean().optional(),
                frequency: z.string().optional(),
                frequencyOtherNumber: z.string().optional(),
                frequencyOtherPeriod: z.string().optional(),
                requires: z.string().nullish(),
            }),
            hair: z.array(z.string()).optional(),
            teeth: z.array(z.string()).optional(),
            other: z.object({
                other: z.array(z.string()).optional(),
                skinCareSpecify: z.string().nullish(),
                compressionHose: z.boolean().optional(),
            }),
            pressureAreasSkinChanges: z
                .object({
                notChecked: z.boolean().optional(),
                findings: z.string().optional(),
            })
                .refine((data) => sectionHasValue(data), {
                message: 'Mark as Not Captured if none applies',
                path: [],
            }),
        }),
        AmbulationLocomotion: z.object({
            ambulation: z.object({
                requiresAmbulation: z.boolean().optional(),
                frequency: z.string().optional(),
                frequencyOtherNumber: z.string().optional(),
                frequencyOtherPeriod: z.string().optional(),
                requires: z.string().optional(),
            }),
            device: z.object({
                devices: z.array(z.string()).optional(),
                other: z.string().optional(),
            }),
            weightBearing: z.object({
                weightBearing: z.array(z.string()).optional(),
                partialLeg: z.array(z.string()).optional(),
                nonLeg: z.array(z.string()).optional(),
            }),
            requiredAssistance: z.object({
                transfers: z.string().optional(),
                other: z.string().optional(),
            }),
        }),
        Other: z.object({
            other: z.object({
                otherOptions: z.array(z.string()).optional(),
                catheterDrainage: z.boolean().optional(),
                assistedWithMedications: z.string().optional(),
                ostomyCare: z.string().optional(),
            }),
            rom: z.array(z.string()).optional(),
            prepare: z.array(z.string()).optional(),
            changedBedLinens: z.object({
                frequency: z.array(z.string()).optional(),
                frequencyOther: z.string().nullish(),
            }),
            pain: z.object({
                painLevel: z.string().optional(),
                activity: z.string().optional(),
            }),
            bowelMovement: z
                .object({
                notCheckedBowelMovement: z.boolean().optional(),
                lastBowelMovement: z.string().optional(),
            })
                .refine((data) => sectionHasValue(data), {
                message: 'Mark as Not Captured if none applies',
                path: [],
            }),
        }),
        Reported: z.string().optional(),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
